import { Card } from '@mui/material'
import React from 'react'
import { ListBase as ReactAdminListBase } from 'react-admin'
import { ListActionsWithPermission } from '../ra-rbac'
import { ListActions } from '../list-actions'
import { Pagination } from '../Pagination'
import ListViewBase from './ListViewBase'
import { ListBaseProps } from './type'

const defaultListAction = {
  hasCreate: true,
  hasExport: true,
  hasPreview: false,
  hasEdit: false,
  hasShow: false,
  hasList: false,
}

const ListBase: React.FC<ListBaseProps> = ({
  children,
  filters = [],
  title,
  listAction = {},
  noCard = false,
  noPagination = false,
  ...props
}) => {
  const FilterActions =
    filters.length > 0 ? (
      <ListActions hasCreate={false} hasExport={false} filters={filters} />
    ) : null

  return (
    <ReactAdminListBase {...props}>
      <ListActionsWithPermission title={title} {...defaultListAction} {...listAction} />
      {!noCard ? (
        <Card>
          {FilterActions}
          <ListViewBase>{children}</ListViewBase>
          {!noPagination && <Pagination />}
        </Card>
      ) : (
        <>
          {FilterActions}
          <ListViewBase>{children}</ListViewBase>
          {!noPagination && <Pagination />}
        </>
      )}
    </ReactAdminListBase>
  )
}

export default ListBase
